import React from 'react';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import useStyles from './assetStyle';

export default function AccordinDet3() {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [country, setCountry] = React.useState('Enter Country');

    const handleChange = (event) => {
        setCountry(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const [formValues, setFormValues] = React.useState({
        country: 'Enter Country Name',
        assetName: 'Enter Name',
        ownership: 'Enter Ownership',
        acqisitionDate: 'Pick Date',
        totInvestment: 'Enter Total',
        assetIncome: 'Enter Income',
        incomeNature: 'Enter Nature',
    });

    return (
        <Grid container spacing={2} className="main-container">
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="country-name">
                        Country Name
                    </InputLabel>
                    <Select
                        disabled
                        id="country-name"
                        className={classes.bottomLine}
                        value={country}
                        open={open}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        onChange={handleChange}
                        IconComponent={() => <FontAwesomeIcon icon={faAngleDown} />}
                    >
                        <MenuItem value="Enter Country">Enter Country</MenuItem>
                        <MenuItem value="India">India</MenuItem>
                        <MenuItem value="Nepal">Nepal</MenuItem>
                        <MenuItem value="Sri Lanka">Sri Lanka</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="asset-name">
                        Name of asset
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="asset-name" value={formValues.assetName} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="ownership">
                        Ownership
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="ownership" value={formValues.ownership} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <TextField
                        id="date"
                        label="Date of Acquisition"
                        type="date"
                        // defaultValue="2020-11-28"
                        InputProps={{ classes: { root: classes.bottomLine }, disabled: true }}
                        InputLabelProps={{
                            classes: {
                                root: classes.inLabel,
                            },
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="tot-investment">
                        Total Investment (at cost) (in Rs.){' '}
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="tot-investment" value={formValues.totInvestment} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="asset-income">
                        Income derived from the asset
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="asset-income" value={formValues.assetIncome} />
                </FormControl>
            </Grid>
            <Grid item xs={10} sm={6} className={classes.marginBtm}>
                <FormControl fullWidth>
                    <InputLabel className={classes.inLabel} htmlFor="income-nature">
                        Nature of income
                    </InputLabel>
                    <Input disabled className={classes.bottomLine} id="income-nature" value={formValues.incomeNature} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.marginBtm}>
                <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                    Add More
                </Button>
            </Grid>
        </Grid>
    );
}
